/**
 * Global constants shared across all composition templates
 */

export const PRESETS = {
	fps: 30,
	dimensions: {
		landscape: { width: 1920, height: 1080 },
		portrait: { width: 1080, height: 1920 },
		square: { width: 1080, height: 1080 },
	},
} as const;

/**
 * Duration for crossfade transitions between audio tracks (in frames)
 */
export const CROSSFADE_DURATION_FRAMES = 30;

/**
 * Minimum duration for any composition (in frames)
 * Equals 5 seconds at 30fps
 */
export const MIN_DURATION_FRAMES = 150;
